module.exports = __webpack_public_path__ + "img/cotton.be5030ca.webp";